import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.date.to-string.js";
import { assert } from "./common/assert";
export function getAccessToken(username, password) {
  return new Promise(function (res, rej) {
    // eslint-disable-next-line fht-eslint-rules/string-literal-validator
    $.post("/token", {
      username: username,
      password: password,
      grant_type: "password"
    }).done(function (d) {
      return res({
        token: d.access_token,
        tokenExpires: new Date(d[".expires"])
      });
    }).fail(function (jqXHR, textStatus) {
      assert(jqXHR.responseJSON, "JQueryXHR falsy");
      var error = jqXHR.responseJSON;

      if (error && error.error_description) {
        rej(new Error(error.error_description));
      } else {
        console.error("Login failed", error);
        rej(new Error("Login failed"));
      }
    });
  });
}